import React from "react";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import * as Variable from "./Variable";

import maatregelenSvg from "../../../../content/images/table/XMLID_3_.svg";
import $ from "jquery";
import * as CommonFunctions from "./functions/commonFunctions";
import ColumnList from "../../../common/componet-jsons/column-list-setting.json";
import * as GC from "../../../common/common";

class Table extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  reloadData(page_number, ids, short_type, direction, field, content = []) {
    var model;
    if (!short_type) {
      if (ids && ids.length) {
        model = {
          content: content,
          context: [
            {
              role: "Beheereenheid zit in folder",
              instance_identifiers: ids,
              direction: "from",
              and_or: "AND",
              start: "2020-11-09T09:56:22.986Z",
            },
          ],
          sorting: [],
          definitions: [process.env.REACT_APP_SETTING_WERKREGELS],
        };
      } else {
        model = {
          content: content,
          definitions: [process.env.REACT_APP_SETTING_WERKREGELS],
          sorting: [],
        };
        window.$settings_werkregels_result = [];
      }
    } else if (short_type) {
      if (ids && ids.length) {
        model = {
          content: content,
          context: [
            {
              role: "Beheereenheid zit in folder",
              instance_identifiers: ids,
              direction: "from",
              and_or: "AND",
              start: "2020-11-09T09:56:22.986Z",
            },
          ],
          sorting: [
            {
              sort_type: short_type,
              direction: direction,
              field: field,
            },
          ],
          definitions: [process.env.REACT_APP_SETTING_WERKREGELS],
        };
      } else {
        model = {
          content: content,
          definitions: [process.env.REACT_APP_SETTING_WERKREGELS],
          sorting: [
            {
              sort_type: short_type,
              direction: direction,
              field: field,
            },
          ],
        };
      }
    }
    window.$settings_werkregels_lastUsedTableFilter = model;
    this.fillTable(model, page_number);
    this.fillFilterColumns();
  }

  fillFilterColumns() {
    var that = this;
    var model = {
      definitions: [process.env.REACT_APP_SETTING_WERKREGELS],
    };
    $.each(window.$settings_werkregels_columnList, function (index, data) {
      if (data.id !== "" && data.filter === true) {
        omnimap
          .FillFilterColumnsAction(
            model,
            data.id,
            window.$settings_werkregels_token
          )
          .then((result) => {
            CallBackFunctions.FillFilterColumnsCallBack(data, result);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }

  fillTable(model, page_number) {
    var that = this;
    window.$settings_werkregels_lastUsedTableFilter = model;

    window.$settings_werkregels_treeChangeStatus = false;
    window.$settings_werkregels_scroll_change = false;

    omnimap
      .GetFreeFormatByIdAction(process.env.REACT_APP_SETTING_WERKREGELS)
      .then((result) => {
        // veri kayıtlı değil
        if (result.meta.total_found == 0) {
          omnimap
            .GetFreeFormatAction("", "POST", window.$settings_post_model)
            .then(() => {
              GC.sleep(1500).then(() => this.fillTable());
            });
        }

        CallBackFunctions.FillTableCallBack(result, page_number);
      });
  }

  addContentAndFillTable(key, value) {
    var hasRow = $.grep(
      window.$settings_werkregels_filterContent,
      function (v) {
        return v.key === key;
      }
    );
    if (hasRow.length > 0) {
      window.$settings_werkregels_filterContent = $.grep(
        window.$settings_werkregels_filterContent,
        function (value) {
          return value !== hasRow[0];
        }
      );
    }
    if (value !== null) {
      var values = [];
      values.push(value);
      var contentModel = {
        and_or: "AND",
        datatype: "STRING",
        key: key,
        values: values,
      };
      window.$settings_werkregels_filterContent.push(contentModel);
    }

    this.reloadData(
      1,
      window.$settings_werkregels_result,
      null,
      null,
      null,
      window.$settings_werkregels_filterContent
    );
  }
  searchFilterColumns(key, searchId) {
    var that = this;
    var model = {
      definitions: [process.env.REACT_APP_SETTING_WERKREGELS],
    };

    omnimap
      .SearchFilterColumnsAction(
        model,
        key,
        searchId,
        window.$settings_werkregels_token
      )
      .then((result) => {
        CallBackFunctions.SearchFilterColumnsCallBack(searchId, result);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  GetActionsOfRow(rowIds) {
    omnimap
      .GetActionsOfRowAction(rowIds, window.$settings_werkregels_token)
      .then(CallBackFunctions.GetActionsOfRowCallback)
      .catch((error) => {
        console.log(error);
      });
  }

  /*** ---PROPSTAN GELEN TREE VERİSİ İÇERİSİNDE TIKLANAN Lİ'NİN TÜM ALT DALLARINDAKİ İDLERİ GETİRİR--- ***/
  treeParser = (data, beheereenheid) => {
    const that = this;
    data.forEach(function (element) {
      if (element.parentfolder === beheereenheid) {
        window.$settings_werkregels_result.push(element.id);
        if (element.children.length > 0) {
          that.treeParser(element.children, element.id);
        }
      } else if (element.children && element.children.length > 0) {
        that.treeParser(element.children, beheereenheid);
      }
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const that = this;
    if (!that.props.location.state) {
      if (that.props.location.isDidUpdate !== prevProps.location.isDidUpdate) {
        var model = {
          content: [],
          definitions: [process.env.REACT_APP_SETTING_WERKREGELS],
        };
        // that.setState({ lastUsedTableFilter: model });
        window.$settings_werkregels_lastUsedTableFilter = model;

        that.reloadData(1);
        document.getElementById("tree-parent-id").setAttribute("value", "");

        var treeClass = document.querySelector(".tree li.open.act");
        var treeDivClass = document.querySelector(".tree li div.open.act");
        if (treeClass !== null) {
          treeClass.removeAttribute("class");
        }
        if (treeDivClass !== null) {
          treeDivClass.classList.remove("open");
          treeDivClass.classList.remove("act");
        }
      } else {
        $("#cover-spin").hide(0);
      }
    } else if (that.props.location.state && prevProps.location.state) {
      if (
        that.props.location.state.isDidUpdate !==
        prevProps.location.state.isDidUpdate
      ) {
        if (that.props.location.state.isDidUpdate == "0038") {
          var model = {
            content: [],
            definitions: [process.env.REACT_APP_SETTING_WERKREGELS],
          };
          // that.setState({ lastUsedTableFilter: model });
          that.reloadData(1);
        } else {
          window.$settings_werkregels_result = [];
          window.$settings_werkregels_result.push(that.props.location.state.id);
          this.treeParser(
            that.props.location.state.TreeList,
            that.props.location.state.id
          );
          if (that.props.location.state.treeLocation !== "modal") {
            that.reloadData(1, window.$settings_werkregels_result);
          }
        }
      }
      //* sayfa f5 ile yenilendiğinde prev props:
      //* temizlenmediğinden dolayı veri gelmemesi sorunu için bu kod çalıştırılıyor.
      else if (window.performance) {
        if (performance.navigation.type == 1) {
          if (that.props.location.state.isDidUpdate == "0038") {
            var model = {
              content: [],
              definitions: [process.env.REACT_APP_SETTING_WERKREGELS],
            };
            // that.setState({ lastUsedTableFilter: model });
            that.reloadData(1);
          } else {
            window.$settings_werkregels_result = [];
            window.$settings_werkregels_result.push(
              that.props.location.state.id
            );
            this.treeParser(
              that.props.location.state.TreeList,
              that.props.location.state.id
            );
            if (that.props.location.state.treeLocation !== "modal") {
              that.reloadData(1, window.$settings_werkregels_result);
            }
          }
        } else {
          alert("This page is not reloaded");
        }
      }
    } else {
      window.$settings_werkregels_result = [];
      window.$settings_werkregels_result.push(that.props.location.state.id);
      this.treeParser(
        that.props.location.state.TreeList,
        that.props.location.state.id
      );
      if (that.props.location.state.treeLocation !== "modal") {
        that.reloadData(1, window.$settings_werkregels_result);
      }
      $("#cover-spin").hide(0);
    }
  }

  async componentDidMount() {
    var that = this;
    if (window.$settings_werkregels_token == null) {
      window.$settings_werkregels_token = GC.GetToken().then((token) => {
        window.$settings_werkregels_token = token;
        this.reloadData(1);
      });
    } else that.reloadData(1);

    ColumnList.forEach(function (item) {
      if (item.name == "settings>werkregels") {
        window.$settings_werkregels_columnList = item["column-list"];
      }
    });
    var table = $("#example").DataTable({
      order: [],
      ordering: false,
      orderCellsTop: true,
      fixedHeader: true,
      colReorder: {
        fixedColumnsLeft: 1
      },
      searching: false,
      paging: false,
      scrollX: "", //"500px",

      scrollCollapse: true,
      scrollY: "calc(100vh - 330px)",

      dom: '<"top"if>t<"bottom"pr><"clear">',
      info: true,
      destroy: true,
      infoCallback: function (settings, start, end, max, total, pre) {
        return (
          '<span class="select-item"></span>' +
          '<span class="total_right"><span id="total-rows" class="total">' +
          end +
          "</span> geselecteerd </span>"
        );
      },
      language: {
        paginate: {
          previous: "Eerste",
          next: "Laatste",
        },
        select: {
          rows: '<span class="items">%d </span>items van&nbsp;', //'<span class="items">%d </span>items van&nbsp;',
        },
      },
      columnDefs: [
        {
          targets: 0,
          data: null,
          defaultContent: "",
          orderable: false,
          className: "select-checkbox",
        },
      ],
      select: {
        style: "multi+shift",
        selector: "tr",
      },
      // Disable sorting on the sorting_disabled class
      aoColumnDefs: [
        {
          bSortable: false,
          aTargets: ["sorting_disabled"],
        },
      ],
    });
    table.columns().iterator("column", function (ctx, idx) {
      if (idx > 1) {
        $(table.column(idx).header()).append('<span class="sort-icon"/>');
      }
    });
    var lastScrollLeft = 0;
    var lastScrollControl = 0.33;
    var buffer = 0.33; // # of pixels from bottom of scroll to fire your function. Can be 0

    $(".dataTables_scrollBody").scroll(function () {
      var documentScrollLeft = $(".dataTables_scrollBody").scrollLeft();
      if (window.$settings_werkregels_scroll_change) {
        if (
          $(".dataTables_scrollBody").prop("scrollHeight") -
            $(".dataTables_scrollBody").scrollTop() <=
          $(".dataTables_scrollBody").height() + buffer
        ) {
          lastScrollControl = 0;
        }
      }
      if (window.$settings_werkregels_scroll_change) {
        if (
          $(".dataTables_scrollBody").prop("scrollHeight") -
            $(".dataTables_scrollBody").scrollTop() <=
          $(".dataTables_scrollBody").height() + buffer
        ) {
          lastScrollControl = 0;
        }
      }
      if (lastScrollLeft == documentScrollLeft + lastScrollControl) {
        if (window.$settings_werkregels_scroll_change) {
          if (
            $(".dataTables_scrollBody").prop("scrollHeight") -
              $(".dataTables_scrollBody").scrollTop() <=
            $(".dataTables_scrollBody").height() + buffer
          ) {
            if (document.getElementById("tableSide").className !== "d-none") {
              if (
                `/${this.baseURI.split("/")[3]}/${
                  this.baseURI.split("/")[4]
                }` === that.props.location.pathname &&
                window.$settings_werkregels_table_total_row_count >
                  process.env.REACT_APP_TABLE_TOTAL_ROW_COUNT
              ) {
                $("#cover-spin").show(0);
                window.$settings_werkregels_page_number++;
                that.fillTable(
                  window.$settings_werkregels_lastUsedTableFilter,
                  window.$settings_werkregels_page_number
                );
              }
            } else window.$settings_werkregels_scroll_change = true;
          }
        }
      }
    });
    $(document).on("click", "#mappen_beheren", function () {
      $("#mappen_beheren_modal").modal("show");
    });
    /*** SETUP - ADD A TEXT INPUT TO EACH FOOTER CELL ***/
    $("#example thead tr").clone(true).appendTo("#example thead");
    $("#example thead tr th").removeClass("sorting_asc");

    $(table.table().header()).addClass("scrollabe-datatable");

    document.getElementsByClassName("scrollabe-datatable")[0].parentElement.id =
      "scrollabe-datatable-id";

    $("#scrollabe-datatable-id thead tr")
      .clone(true)
      .appendTo("#scrollabe-datatable-id thead");

    $("#scrollabe-datatable-id thead tr:eq(1) th").each(function (i) {
      if (i > 1) {
        var title = $(this).text();
        var row = $.grep(window.$settings_werkregels_columnList, function (v) {
          return v.row === i;
        });
        var rowId = row[0].id;
        if (row[0].filter === true) {
          $(this).html(
            '<input type="search" class="col-search" id="' + rowId + '" />'
          );
          $("input", this).on("keyup change", function () {
            if (table.column(i).search() !== this.value) {
              table.column(i).search(this.value).draw();
            }
          });
        } else {
          $(this).html("");
        }
      } else if (i === 0) {
        $(this).html(
          //$(this).html( '<div class="popup threedots" onclick="Popup()"><span class="popuptext" id="myPopup"><a class="maatregelen" href="#">Maatregelen</a><a class="locate" href="#">Beheer gebieden</a><a class="map" href="#">Toon op kaart</a><a class="trash-bin" href="#">Verwijderen</a></span></div>' );
          '<div class="popup threedots"><span class="popuptext" id="myPopup"></span></div>'
        );
      } else if (i === 1) {
        $(this).html('<div class="refresh"> </div>');
      } else {
        $(this).html("");
      }
    });

    $("#scrollabe-datatable-id thead").on("click", "th", function () {
      var row_index = table.column(this).index();

      if (row_index != undefined && row_index != 0) {
        var nRow = $("#scrollabe-datatable-id thead tr")[0];
        if (
          this.childNodes[0].className != "popup threedots" &&
          this.childNodes[0].className != "col-search ui-autocomplete-input" &&
          this.childNodes[0].className != "refresh"
        ) {
          nRow.childNodes.forEach(function (indx) {
            if (indx.cellIndex != row_index) {
              indx.className = "sorting_disabled";
            }
          });

          if (row_index) {
            if (this.className == "sorting_disabled") {
              this.className = "sorting_asc";
              var row;
              $.each(
                window.$settings_werkregels_columnList,
                function (index, data) {
                  if (data.row == row_index) {
                    row = data;
                  }
                }
              );
              that.reloadData(
                1,
                window.$settings_werkregels_result,
                row.shortType,
                "ASCENDING",
                row.shortField,
                window.$settings_werkregels_filterContent
              );
            } else if (this.className == "sorting_asc") {
              this.className = "sorting_desc";
              var row;
              $.each(
                window.$settings_werkregels_columnList,
                function (index, data) {
                  if (data.row == row_index) {
                    row = data;
                  }
                }
              );
              that.reloadData(
                1,
                window.$settings_werkregels_result,
                row.shortType,
                "DESCENDING",
                row.shortField,
                window.$settings_werkregels_filterContent
              );
            } else if (this.className == "sorting_desc") {
              this.className = "sorting_asc";
              var row;
              $.each(
                window.$settings_werkregels_columnList,
                function (index, data) {
                  if (data.row == row_index) {
                    row = data;
                  }
                }
              );
              that.reloadData(
                1,
                window.$settings_werkregels_result,
                row.shortType,
                "ASCENDING",
                row.shortField,
                window.$settings_werkregels_filterContent
              );
            }
          }

          window.$settings_werkregels_page_number = 1;
        }
      }
    });

    $("#example tbody").on("click", "tr", function () {
      if ($(".checkAll").attr("style") == "display: none;") {
        $(".checkNone, .checkAll").toggle();
      }
    });

    //** select all table
    $("#scrollabe-datatable-id").on("click", ".checkAll", function (e) {
      var table = $("#example").DataTable();
      table.rows().select();

      $(".checkNone, .checkAll").toggle();
    });

    //** unselect all table
    $("#scrollabe-datatable-id").on("click", ".checkNone", function (e) {
      var table = $("#example").DataTable();

      table.rows().deselect();
      $(".checkNone, .checkAll").toggle();
    });

    $("#example_filter input").addClass("search-input-table1");
    $(".search-input-table1").attr("placeholder", "search text");

    $("#example tbody").on("dblclick", "tr", function () {
      // var rowId = this.attributes[1].value;
      var rowId = $(this).attr("rowId");

      $.each(window.$settings_werkregels_Glist, function (index, data) {
        if (data.fieldName == rowId) {
          window.$settings_werkregels_selectedRow = data;
          that.props.history.push("/settings/werkregels/detail/" + rowId, {
            rowData: data,
          });
        }
      });

      // CommonFunctions.fillDetail();
      // $("#tableSide").addClass("d-none");
      // $("#detailSide").removeClass("d-none");
    });

    /*** ---OPTION TO ALLOW SELECTING ROWS BY CLICKING ON ROW BESIDES CHECKBOX--- ***/
    // $("#example tbody").on("click", "tr", function () {
    //   $(this).toggleClass("selected");
    // });

    $("#algemeen-code").autocomplete({
      source: window.$settings_werkregels_algemeenCode,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-code", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-naam").autocomplete({
      source: window.$settings_werkregels_algemeenNaam,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-naam", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-code").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-naam").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });

    $(".col-search").on("input", function (e) {
      if (this.value === "") {
        that.addContentAndFillTable($(this).attr("id"), null);
      }
    });
    function handleRefresh () {
      $("#cover-spin").show(0);
      $("#spinner").removeAttr("hidden");
      that.fillTable(window.$settings_werkregels_lastUsedTableFilter, 1);
      // that.reloadData(1);
    }
    window.$settings_werkregels_refresh = handleRefresh;
    $(".refresh").click(handleRefresh);

    $("div.popup").click(function () {
      var test = this;
      var selectedIds = [];
      $("#example")
        .dataTable()
        .$("tr.selected")
        .each(function () {
          selectedIds.push($(this).attr("rowId"));
        });
      // that.setState({ selectedIds: selectedIds });
      window.$settings_werkregels_selectedIds = selectedIds;
      that.GetActionsOfRow(selectedIds.join(","));
    });

    $(document).on("click", "#verwijderen", function () {
      if (window.$settings_werkregels_selectedIds == 0) {
        alert("rows not selected");
      } else {
        $("#management-units-mappen_beheren_delete_modal").modal("show");
      }
    });

    function koppelAanFolderCallBack() {
      GC.sleep(2000).then(() => {
        $("#cover-spin").hide(0);

        $("#modal_koppel_aan_folder").modal("hide");
        that.reloadData(1);
      });
    }

    $(document).on("click", "#management-units-koppel-aan-folder", () => {
      $("#cover-spin").show(0);

      var model = {
        action: "ADD",
        contextRol: "Beheereenheid zit in folder",
        folder: document.getElementById("tree-parent-id").value,
      };
      GC.StartActivity(
        model,
        window.$settings_werkregels_selectedIds,
        "708371ee-e3f6-4de7-87f8-dfe94b86f9b1",
        koppelAanFolderCallBack(),
        window.$settings_werkregels_token
      );
    });

    $(document).on("click", ".mm_work_plans_action", function () {
      var actionId = $(this).attr("id");
      let modalId = window.$mm_work_plans_actions.filter(
        (act) => act["id"] === actionId
      )[0]["modal"];
      $("#" + modalId).modal("show");
    });
  }

  render() {
    return (
      <div id="tableSide">
        <table id="example" className="table-hover table min-full-width">
          <thead>
            <tr>
              <th className="sorting_disabled" style={{ width: "1%" }}>
                <span className="checkAll" />
                <span className="checkNone" style={{ display: "none" }} />
              </th>
              <th className="sorting_disabled" style={{ width: "1%" }}>
                {/* <img
                  className="icon-table"
                  src={maatregelenSvg}
                  width={18}
                  height={18}
                /> */}
              </th>
              <th>Veldnaam</th>
              <th>Alias</th>
              <th>Zichtbaar</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
        <input id="tree-parent-id" hidden />
        <input id="tree-parent-name" hidden />
      </div>
    );
  }
}

export default Table;
